export default "__VITE_ASSET__DWU9pBUH__"